module.exports = __webpack_public_path__ + "img/teacher_avartar.61456a73.png";